import { useCallback } from 'react';
import { getCookie } from '@pv/common/utils';
const HUBSPOT_FORMS_API_V3_URL =
  'https://api.hsforms.com/submissions/v3/integration/submit';

/**
 * Submit a form to HubSpot
 * @param portalId - The HubSpot portal ID
 * @param formId - The HubSpot form ID
 * @returns A function that submits the form
 */
export const useSubmitHubspotForm = <T extends Record<string, string>>(
  portalId: string,
  formId: string
) => {
  const submitForm = useCallback(
    async (fields: T) => {
      if (!portalId || !formId) return false;

      const hutk = getCookie('hubspotutk');

      const context = {
        hutk,
        pageUri: window.location.href,
        pageName: document.title,
      };

      try {
        const response = await fetch(
          `${HUBSPOT_FORMS_API_V3_URL}/${portalId}/${formId}`,
          {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
            body: JSON.stringify({
              submittedAt: Date.now(),
              fields: Object.entries(fields).map(([key, value]) => ({
                name: key,
                value: value ?? '',
              })),
              context,
            }),
          }
        );

        return response.ok;
      } catch (err) {
        console.warn('HubSpot tracking failed:', err);
        return false;
      }
    },
    [formId, portalId]
  );

  return submitForm;
};
